"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Tabs = void 0;
var react_1 = __importDefault(require("react"));
var tabs_1 = require("@reach/tabs");
/**
 * {@link https://cultureamp.design/components/tabs/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-tabs--controlled Storybook}
 *
 * Wrapper around the whole thing: holds a tab list and tab panels
 */
var Tabs = function (props) {
    var defaultIndex = props.defaultIndex, selectedIndex = props.selectedIndex, _a = props.keyboardActivation, keyboardActivation = _a === void 0 ? "auto" : _a, onChange = props.onChange, children = props.children;
    return (react_1["default"].createElement(tabs_1.Tabs, { defaultIndex: defaultIndex, index: selectedIndex, keyboardActivation: keyboardActivation === "auto"
            ? tabs_1.TabsKeyboardActivation.Auto
            : tabs_1.TabsKeyboardActivation.Manual, onChange: onChange }, children));
};
exports.Tabs = Tabs;
exports.Tabs.displayName = "Tabs";
//# sourceMappingURL=Tabs.js.map